var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0006 4H4.00065C2.66732 4 1.33398 5.33333 1.33398 6.66667V25.3333C1.33398 26.8 2.53398 28 4.00065 28H28.0006C29.334 28 30.6673 26.6667 30.6673 25.3333V6.66667C30.6673 5.33333 29.334 4 28.0006 4ZM7.50732 21.5867L10.8273 17.32C11.094 16.9867 11.6006 16.9733 11.8673 17.3067L14.6673 20.68L18.8007 15.36C19.0673 15.0133 19.6006 15.0133 19.8673 15.3733L24.5473 21.6133C24.8806 22.0533 24.5606 22.68 24.014 22.68H8.02732C7.48065 22.6667 7.16065 22.0267 7.50732 21.5867Z",
    fill: "#2F3133",
    fillOpacity: 0.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoDefault);
export default __webpack_public_path__ + "static/media/photo-default.7fb49d730f47ce1133b449978c493f27.svg";
export { ForwardRef as ReactComponent };